// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wob-appmenu-label-container {
    display: inline-block;
    vertical-align: top;
    text-align: right;
    width: 13.5em;
}

.wob-appmenu-label-container .appmenu-label,
.wob-appmenu-label-container .wob-appmenu-sublabel {
    display: block;
}

.wob-appmenu-label-container .wob-appmenu-sublabel {
    font-size: 75%;
    font-weight: normal;
}

.wob-appmenu-label-container .wob-appmenu-sublabel-themetitle,
.wob-appmenu-label-container .wob-appmenu-sublabel-separator,
.wob-appmenu-label-container .wob-appmenu-sublabel-username {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
}

.wob-appmenu-label-container .wob-appmenu-sublabel-themetitle,
.wob-appmenu-label-container .wob-appmenu-sublabel-username {
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./qwc2-wob/components/style/AppMenuLabel.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,uBAAuB;AAC3B","sourcesContent":[".wob-appmenu-label-container {\n    display: inline-block;\n    vertical-align: top;\n    text-align: right;\n    width: 13.5em;\n}\n\n.wob-appmenu-label-container .appmenu-label,\n.wob-appmenu-label-container .wob-appmenu-sublabel {\n    display: block;\n}\n\n.wob-appmenu-label-container .wob-appmenu-sublabel {\n    font-size: 75%;\n    font-weight: normal;\n}\n\n.wob-appmenu-label-container .wob-appmenu-sublabel-themetitle,\n.wob-appmenu-label-container .wob-appmenu-sublabel-separator,\n.wob-appmenu-label-container .wob-appmenu-sublabel-username {\n    display: inline-block;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.wob-appmenu-label-container .wob-appmenu-sublabel-themetitle,\n.wob-appmenu-label-container .wob-appmenu-sublabel-username {\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
